import React from 'react';
import PropTypes from "prop-types";
import {useQuery} from "@tanstack/react-query";
import {getOrganizations} from "../api";
import FullscreenSpinner from "../components/FullscreenSpinner";
import { useLocation } from 'react-router-dom';

const OrganizationListContext = React.createContext({});

function OrganizationListContextProvider({children}) {
    const location = useLocation();
    const isMetricsPage = location.pathname.endsWith('/metrics');

    const organizationQuery = useQuery({
        queryKey: [`organizations`],
        queryFn: (arg) => {
            return getOrganizations();
        },
        refetchOnWindowFocus: true,
        staleTime: Infinity,
        refetchInterval: () => isMetricsPage ? false : 15000,
    });

    const organizationDataAvailable = ( organizationQuery.isSuccess && organizationQuery.data );

    if (!organizationDataAvailable)
        return  <FullscreenSpinner />;

    const loggedIn = organizationQuery.data.loggedIn;
    const orgList = organizationQuery.data.organizations;

    const context = {loggedIn, orgList, organizationQuery};

    return <OrganizationListContext.Provider value={context}>
        { children }
    </OrganizationListContext.Provider>;
}

OrganizationListContextProvider.propTypes = {
    children: PropTypes.element
};

export {OrganizationListContextProvider as default, OrganizationListContext};